<div class="modal-overlay" (click)="close.emit()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Remote Control: {{ deviceName }}</h2>
      <button class="close-btn" (click)="close.emit()">&times;</button>
    </div>
    
    <div class="modal-body">
      <div class="status-box" *ngIf="commandStatus" [ngClass]="{'sending': isSending, 'success': commandStatus.includes('success'), 'error': commandStatus.includes('failed') || commandStatus.includes('Error')}">
        {{ commandStatus }}
      </div>

      <a *ngIf="logDownload" class="log-download-link" data-testid="log-download-link" [href]="logDownload.url" target="_blank" rel="noopener" download>
        {{ logDownload.label }}
      </a>

      <div class="commands-grid">
        <button *ngFor="let cmd of commands" 
                class="command-btn" 
                (click)="onCommandClicked(cmd.action, cmd.label)"
                [disabled]="isSending">
          {{ cmd.label }}
        </button>
      </div>

      <hr class="section-divider" />
      
      <div class="schedule-section">
        <h3 class="schedule-title">Automatic Restart Schedule</h3>
        <p class="schedule-desc">Configure an automatic machine restart schedule. Time is based on the local time of the machine.</p>
        
        <div class="schedule-checkbox-row">
          <input type="checkbox" id="nightlyRestart" [(ngModel)]="nightlyRestartEnabled" class="checkbox-input" />
          <label for="nightlyRestart" class="checkbox-label">Enable Nightly Machine Restart</label>
        </div>

        <div class="schedule-time-row">
          <label for="restartTime" class="time-label">Restart Time:</label>
          <input type="time" id="restartTime" [(ngModel)]="autoRestartTime" [disabled]="!nightlyRestartEnabled" class="time-input" />
        </div>

        <div class="schedule-action-row">
          <button class="btn-save-schedule" 
                  (click)="saveSchedule()" 
                  [disabled]="isSavingSchedule">
            {{ isSavingSchedule ? 'Saving...' : 'Save Schedule' }}
          </button>
          <span *ngIf="scheduleStatus" class="schedule-status-text" 
                [ngClass]="{'status-error': scheduleStatus.includes('Error'), 'status-success': !scheduleStatus.includes('Error')}">
            {{ scheduleStatus }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Date Selection Prompt Dialog for Logs -->
  <div class="date-prompt-overlay" *ngIf="showDateDialog" (click)="$event.stopPropagation()">
    <div class="date-prompt-card">
      <div class="date-prompt-header">
        <h3 class="date-prompt-title">Select Date for {{ pendingLogTitle }}</h3>
        <button class="close-btn" (click)="cancelDatePrompt()">&times;</button>
      </div>
      <div class="date-prompt-body">
        <p class="date-prompt-instruction">
          Specify the target date of the {{ pendingLogTitle }} file to pull from the kiosk:
        </p>
        <div class="date-input-container">
          <label for="logDateInput" class="date-input-label">Log Date:</label>
          <input 
            type="date" 
            id="logDateInput" 
            [(ngModel)]="selectedLogDate" 
            class="log-date-input" 
          />
        </div>
        <div class="quick-date-buttons">
          <button type="button" class="btn-quick-date" (click)="setLogDateToday()">Today</button>
          <button type="button" class="btn-quick-date" (click)="setLogDateYesterday()">Yesterday</button>
        </div>
      </div>
      <div class="date-prompt-footer">
        <button class="btn-cancel" (click)="cancelDatePrompt()" [disabled]="isSending">Cancel</button>
        <button class="btn-fetch-log" (click)="confirmDateAndFetchLog()" [disabled]="!selectedLogDate || isSending">
          Fetch Log
        </button>
      </div>
    </div>
  </div>
</div>
